<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar.value"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.color"
          text
          v-bind="attrs"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name : 'SnackBar',
  computed: {
    ...mapGetters({
        snackbar: "Global/snackbar",
    }),
  },
}
</script>

<style>

</style>